import { ROUTE_MAP } from './url';

export const OVERVIEW_SCENE_ID = '68d12cca208f82c724e17eb7';
export const OVERVIEW_GROUP_ID = '68d11f8df1fff2aa8e505161';

export const APARTMENT_SCENE_ID = '68e78ba6fa4f187e528e4525';
export const APARTMENT_GROUP_ID = '68f0a5034ac102ae931e9ee3';

export const SCENES_MAP = {
  [OVERVIEW_SCENE_ID]: {
    label: 'Tổng quan NewStar',
    short: 'Tổng quan',
    url: `/${ROUTE_MAP.overview.id}`,
    groupId: OVERVIEW_GROUP_ID,
  },
  [APARTMENT_SCENE_ID]: {
    label: 'Căn hộ mẫu',
    short: 'Căn hộ mẫu',
    url: `/${ROUTE_MAP['can-ho-mau']?.id || 'can-ho-mau'}`,
    groupId: APARTMENT_GROUP_ID,
  },
};
